<script>

    import { toast } from 'bulma-toast'
    import { modalStore } from '../stores'

    import ChargesService from '../$services/charges.service'
    import DateMethods from '../$methods/date.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import Modal from '../$components/modal.container.svelte'
    import Table from '../$components/table.svelte'
    import ChargesCards from './component.charges.cards.svelte'
    import ChargesRows from './component.charges.rows.svelte'

    const partners = {
        FedEx: 'FedEx cuenta',
        skydropx: 'Skydropx',
        t1envios: 'T1envios',
        drenvio: 'Drenvio'
    }

    let imports = []
    let loading = false
    let detail = null

    getImports()

    export async function getImports() {

        loading = true
        const resp = await ChargesService.getChargeImports()
        loading = false

        if(!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        imports = resp.data
    }

    async function openDetail(item) {

        const resp = await ChargesService.getChargeImport(item._id)

        if(!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        detail = resp.data
        modalStore.open('charges_import_modal')
    }

</script>

<Table items={ imports.length } { loading } skeletonCols={10}>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <ButtonModal modalId="charges_upload_modal" text="Cargar cargos" icon="upload" />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar-plus"></i></span>
                    <span>Fecha</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Partner</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-file-invoice"></i></span>
                    <span>Factura</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-check"></i></span>
                    <span>Encontradas</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-times"></i></span>
                    <span>No encontradas</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-receipt"></i></span>
                    <span>Con costo</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>A cobrar</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-file-excel"></i></span>
                    <span>Archivo</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Detalle</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each imports as item, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ DateMethods.dateTimeShort(item.created) }</td>
                <td>{ partners[item.partner] || item.partner }</td>
                <td>{ item.invoice || '' }</td>
                <td>{ item.found }</td>
                <td>{ item.missing }</td>
                <td>{ item.withCost }</td>
                <td>{ NumeralMethods.cash(item.amount) }</td>
                <td>
                    {#if item.file}
                        <a href={ item.file } target="_blank" rel="noreferrer">{ item.fileName || 'Archivo' }</a>
                    {:else}
                        { item.fileName || '' }
                    {/if}
                </td>
                <td>
                    <Button on:click={() => openDetail(item)} icon="eye" size="small" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>

<Modal id="charges_import_modal" title={ detail?.invoice || detail?.fileName || 'Detalle' } tall>
    {#if detail}
        <ChargesCards
            found={ detail.found }
            missing={ detail.missing }
            withCost={ detail.withCost }
            review={ detail.review }
            amount={ detail.amount }
        />
        <ChargesRows rows={ detail.rows || [] } partner={ detail.partner } />
    {/if}
</Modal>
